var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Settle-info" },
    [
      _c(
        "h1",
        {
          staticStyle: {
            "text-align": "center",
            "font-size": "0.35rem",
            "margin-top": "80px",
          },
        },
        [_vm._v("加入我们")]
      ),
      _c("ul", { staticClass: "Customer-Type" }, [
        _c(
          "li",
          {
            class: _vm.ruleForm.clientKey == 1 ? "li-active" : "li-moren",
            on: {
              click: function ($event) {
                _vm.ruleForm.clientKey = 1
              },
            },
          },
          [_vm._v("行业用户")]
        ),
        _c(
          "li",
          {
            class: _vm.ruleForm.clientKey == 0 ? "li-active" : "li-moren",
            on: {
              click: function ($event) {
                _vm.ruleForm.clientKey = 0
              },
            },
          },
          [_vm._v("供应商")]
        ),
      ]),
      _vm.ruleForm.clientKey == 0
        ? _c(
            "div",
            { staticClass: "card" },
            _vm._l(_vm.cardArr, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: item.mouseleaveShow
                    ? "Settle-content Settle-content-enter"
                    : "Settle-content",
                  on: {
                    click: function ($event) {
                      return _vm.settle(item)
                    },
                    mouseleave: function ($event) {
                      return _vm.mouseleave($event, item)
                    },
                    mouseenter: function ($event) {
                      return _vm.mouseenter($event, item)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "card-top-pic",
                    staticStyle: {
                      width: "-webkit-fill-available",
                      height: "190px",
                    },
                    attrs: { src: item.img, alt: "" },
                  }),
                  _c(
                    "div",
                    { staticClass: "card-content card-content-point" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "Name-Remark",
                          staticStyle: { padding: "10px" },
                        },
                        [
                          _c("p", [_vm._v(_vm._s(item.name))]),
                          _c("p", [_vm._v(_vm._s(item.remark))]),
                        ]
                      ),
                      _c("el-button", {
                        staticStyle: {
                          height: "fit-content",
                          padding: "7px",
                          "margin-bottom": "7px",
                          "margin-right": "7px",
                        },
                        attrs: { icon: "el-icon-back", circle: "" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.ruleForm.clientKey == 1
        ? _c(
            "div",
            { staticClass: "card" },
            _vm._l(_vm.ptCardArr, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: item.mouseleaveShow
                    ? "Settle-content Settle-content-enter"
                    : "Settle-content",
                  on: {
                    click: function ($event) {
                      return _vm.settle(item)
                    },
                    mouseleave: function ($event) {
                      return _vm.mouseleave($event, item)
                    },
                    mouseenter: function ($event) {
                      return _vm.mouseenter($event, item)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "card-top-pic",
                    staticStyle: {
                      width: "-webkit-fill-available",
                      height: "190px",
                    },
                    attrs: { src: item.img, alt: "" },
                  }),
                  _c(
                    "div",
                    { staticClass: "card-content card-content-point" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "Name-Remark",
                          staticStyle: { padding: "10px" },
                        },
                        [
                          _c("p", [_vm._v(_vm._s(item.name))]),
                          _c("p", [_vm._v(_vm._s(item.remark))]),
                        ]
                      ),
                      _c("el-button", {
                        staticStyle: {
                          height: "fit-content",
                          padding: "7px",
                          "margin-bottom": "7px",
                          "margin-right": "7px",
                        },
                        attrs: { icon: "el-icon-back", circle: "" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.settleDialogShow,
            width: "25%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.settleDialogShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "top-logo" }, [
            _c("img", {
              attrs: { src: require("../../assets/png/logo-png.png"), alt: "" },
            }),
            _vm.ruleForm.clientKey == 0
              ? _c("p", [_vm._v("供应商注册")])
              : _vm._e(),
            _vm.ruleForm.clientKey == 1
              ? _c("p", [_vm._v("平台注册")])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "Settle-content-phone" },
            [
              _c("p", { staticClass: "phoneYz" }, [_vm._v("手机号验证")]),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-input", {
                        attrs: {
                          "prefix-icon": "el-icon-user",
                          placeholder: "请输入昵称",
                        },
                        model: {
                          value: _vm.ruleForm.nikeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "nikeName", $$v)
                          },
                          expression: "ruleForm.nikeName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "phoneNumber" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-with-select",
                          attrs: {
                            "prefix-icon": "el-icon-phone",
                            placeholder: "请输入手机号码",
                          },
                          model: {
                            value: _vm.ruleForm.phoneNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "phoneNumber", $$v)
                            },
                            expression: "ruleForm.phoneNumber",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "85px" },
                              attrs: { slot: "prepend", placeholder: "请选择" },
                              slot: "prepend",
                              model: {
                                value: _vm.selectAreaNo,
                                callback: function ($$v) {
                                  _vm.selectAreaNo = $$v
                                },
                                expression: "selectAreaNo",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "+86", value: "1" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-input", {
                        staticClass: "input-with-select",
                        staticStyle: { "margin-right": "5px" },
                        attrs: { placeholder: "请输入验证码" },
                        model: {
                          value: _vm.ruleForm.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "code", $$v)
                          },
                          expression: "ruleForm.code",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "background-color": "#3a62d7" },
                          attrs: { type: "primary" },
                        },
                        [
                          _vm.count < 1 || _vm.count === ""
                            ? _c("span", { on: { click: _vm.verify } }, [
                                _vm._v("获取验证码"),
                              ])
                            : _c("span", [
                                _vm._v(
                                  "(" + _vm._s(_vm.count) + "s)后重新获取"
                                ),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-with-select",
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            type: _vm.iconShow ? "text" : "password",
                            placeholder: "请输入密码",
                          },
                          model: {
                            value: _vm.ruleForm.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "password", $$v)
                            },
                            expression: "ruleForm.password",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "append" },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  iconClass: _vm.iconShow
                                    ? "passwordShow"
                                    : "passwordHide",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.iconShow = !_vm.iconShow
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-with-select",
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            type: _vm.iconShow1 ? "text" : "password",
                            placeholder: "请再次确认密码",
                          },
                          model: {
                            value: _vm.ruleForm.confirmPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "confirmPassword", $$v)
                            },
                            expression: "ruleForm.confirmPassword",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "append" },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  iconClass: _vm.iconShow1
                                    ? "passwordShow"
                                    : "passwordHide",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.iconShow1 = !_vm.iconShow1
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    { staticStyle: { "font-size": "12px", color: "#DCDFE6" } },
                    [
                      _vm._v(
                        "亲，注册成功后填写您的入驻信息，审核通过后，即可将您的商品呈现给众多行业用户"
                      ),
                    ]
                  ),
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "zcButton",
                        staticStyle: { "background-color": "#3a62d7" },
                        on: { click: _vm.verificationSupplier },
                      },
                      [_vm._v("注册用户账号")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.verifyShow,
            width: "25%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.verifyShow = $event
            },
          },
        },
        [
          _c("slide-verify", {
            ref: "slideblock",
            staticStyle: { margin: "0 auto" },
            attrs: { imgs: _vm.imgs },
            on: { success: _vm.onSuccess, fail: _vm.onFail },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "注册提醒",
            visible: _vm.companyShow,
            width: "40%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.companyShow = $event
            },
          },
        },
        [
          _c("p", { staticStyle: { "margin-top": "5px" } }, [
            _vm._v("系统检测该账户下已存在如下公司主体,是否使用?"),
          ]),
          _c("p", { staticStyle: { "margin-top": "5px" } }, [
            _vm._v("所属机构：麦格仕国际旅行社"),
          ]),
          _c(
            "span",
            {
              staticClass: "footer",
              staticStyle: {
                "margin-top": "15px",
                display: "flex",
                "justify-content": "flex-end",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.companyShowPoint(0)
                    },
                  },
                },
                [_vm._v("不用了，直接生成新的主体")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.companyShowPoint(1)
                    },
                  },
                },
                [_vm._v("确认使用该主体")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }